import moment from 'moment';
import Pluralize from 'pluralize';
import React from 'react';
import { Tooltip } from '../../../../Shared/index';
import activityFromClassificationId from '../../modules/activity_from_classification_id.js';

import { nonRelevantActivityClassificationIds, } from '../../../../../modules/activity_classifications';
import PreviewOrLaunchModal from '../../shared/preview_or_launch_modal';

const styles = {
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  endRow:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '242px',
  },
  lessonEndRow:{
    display: 'flex',
    width: '100%',
    maxWidth: '390px',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  reportEndRow:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '15px',
  }
}

export default class ClassroomActivity extends React.Component {
  activityId = () => {
    const { data, } = this.props
    return data.activityId || data.activityUid || data.activity.uid;
  }

  activityName = () => {
    const { data, } = this.props
    return data.name || data.activity.name;
  }

  calculateAverageScore = () => {
    const { data, } = this.props
    const averageScore = data.cumulativeScore / data.completedCount;
    if (isNaN(averageScore)) {
      return '—';
    } else if (nonRelevantActivityClassificationIds.includes(data.activityClassificationId)) {
      return (
        <Tooltip
          tooltipText="This type of activity is not graded."
          tooltipTriggerText="N/A"
        />
      )
    } else if (Math.round(averageScore).toString().length === 2) {
      return `${averageScore.toPrecision(2)}%`;
    }
    return `${averageScore}%`;
  }

  classification = () => {
    const { data, } = this.props
    return data.activityClassificationId;
  }

  classroomId = () => {
    const { data, } = this.props
    return data.classroomId || data.classroom_id;
  }

  classroomUnitId = () => {
    const { data, } = this.props
    return data.cuId || data.classroom_unit_id;
  }

  finalCell = () => {
    const { data, numberOfStudentsAssignedToUnit, isFirst, } = this.props

    return [
      <span className="number-of-students" key="number-of-students">{this.renderPieChart()} {data.completedCount} of {numberOfStudentsAssignedToUnit} {Pluralize('student', numberOfStudentsAssignedToUnit)}</span>,
      <span className="average-score" key="average-score">{this.calculateAverageScore()}</span>,
      <button aria-label={`View report for ${this.activityName()}`} className="interactive-wrapper focus-on-light" onClick={this.handleReportLinkClick} type="button"><img alt="" className="chevron-right" key="chevron-right" src="https://assets.quill.org/images/icons/chevron-dark-green.svg" /></button>
    ];
  }

  handleReportLinkClick = () => {
    $.get(`/teachers/progress_reports/report_from_unit_and_activity/u/${this.unitId()}/a/${this.activityId()}`)
      .success(data => window.location = data.url)
      .fail(() => alert('This report is not yet available. Please check back when at least one of your students has completed this activity.'));
  }

  icon = () => {
    const { data, } = this.props
    const classification = this.classification();
    if (classification) {
      // then we're coming from the index and have an id
      return `icon-${activityFromClassificationId(classification)}-green-no-border`;
    }
    // it is stupid that we are passing this in some of this components use create_activity_sessions
    //  but don't have time to deprecate it right now
    return data.activity && data.activity.classification ? data.activity.classification.green_image_class : '';
  }

  uaId = () => {
    const { data, } = this.props
    return data.uaId || data.ua_id;
  }

  unitId = () => {
    const { unitId, data, } = this.props
    return unitId || data.unit_id;
  }

  renderPieChart = () => {
    const { data, numberOfStudentsAssignedToUnit, } = this.props
    const rawPercent = data.completedCount / numberOfStudentsAssignedToUnit;
    const percent = rawPercent > 100 ? 100 : Math.round(rawPercent * 100) / 100;
    const largeArcFlag = percent > 0.5 ? 1 : 0;
    const pathData = `M 1 0 A 1 1 0 ${largeArcFlag} 1 ${Math.cos(2 * Math.PI * percent)} ${Math.sin(2 * Math.PI * percent)} L 0 0`;
    return (
      <svg className="activity-analysis-pie-chart" viewBox="-1 -1 2 2">
        <path d={pathData} fill="#348fdf" />
      </svg>
    );
  }

  render = () => {
    const endRow = Object.assign({}, styles.reportEndRow, { width: '350px' });

    return (
      <div className="row activity" onClick={this.handleReportLinkClick} style={Object.assign({}, styles.row)}>
        <div className="starting-row">
          <div className="cell">
            <div className={`pull-left icon-wrapper ${this.icon()}`} />
          </div>
          <div className="cell activity-analysis-activity-name">{this.activityName()}</div>
        </div>
        <div className='cell activity-analysis-row-right' style={endRow}>
          {this.finalCell()}
        </div>
      </div>
    );
  }
};
